import React from 'react';

interface IconButtonProps {
  icon: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'small' | 'medium' | 'large';
  className?: string;
  ariaLabel?: string;
}

export default function IconButton({
  icon,
  onClick,
  variant = 'ghost',
  size = 'medium',
  className = '',
  ariaLabel,
}: IconButtonProps) {
  const variantClasses = {
    primary: 'bg-[#E31837] text-white hover:bg-[#C41530]',
    secondary: 'bg-[#006491] text-white hover:bg-[#005278]',
    ghost: 'bg-gray-100 text-gray-700 hover:bg-gray-200',
  };
  
  const sizeClasses = {
    small: 'w-10 h-10',
    medium: 'w-12 h-12',
    large: 'w-14 h-14',
  };
  
  const iconSizes = {
    small: 'text-lg',
    medium: 'text-xl',
    large: 'text-2xl',
  };
  
  return (
    <button
      onClick={onClick}
      aria-label={ariaLabel}
      className={`rounded-full flex items-center justify-center transition-all ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
    >
      <i className={`${icon} ${iconSizes[size]}`}></i>
    </button>
  );
}
